export default __webpack_public_path__ + "static/media/area-50.f5575aad.jpg";